<template>
  <div class="view pa24">

    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="140px" class="ruleForm">
        <el-form-item label="所属父级" prop="parentName">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull" :disabled="isShow"
            v-model="parentName" style="width: 300px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.id"
              style="display: none;" />
              <div class="searchWrap">
                <div class="searchItem">
                  <span class="searchName">名称</span>
                  <el-input placeholder="输入名称关键字进行过滤" v-model="filterText" style="margin: 0 5px; width: 98%">
                  </el-input>
                </div>
                <div class="searchItem">
                  <span class="searchName">规格</span>
                  <el-input placeholder="输入规格关键字进行过滤" v-model="specName" style="margin: 0 5px; width: 98%">
                  </el-input>
                </div>
                <div class="searchItem">
                  <span class="searchName">件号/存货编号</span>
                  <el-input placeholder="输入件号/存货编号进行过滤" v-model="partNumber" style="margin: 0 5px; width: 98%">
                  </el-input>
                </div>
              </div>

            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
              highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode" :lazy="true"
              :load="load" collapse-tags />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-select v-model="ruleForm.unit" placeholder="请选择">
            <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格" prop="specName">  
          <el-input v-model="ruleForm.specName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="件号" prop="partNumber">
          <el-input v-model="ruleForm.partNumber" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="modelNo">
          <el-input v-model="ruleForm.modelNo" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="存货编码" prop="inventCode">
          <el-input v-model="ruleForm.inventCode" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="材料牌号" prop=""  v-if="companyName.includes('利佳')">
          <el-input v-model="ruleForm.goodsCode" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="缩略规格"  v-if="companyName.includes('利佳')">
          <el-input v-model="ruleForm.specCode" :readonly="isShow"></el-input>
        </el-form-item> 
        <el-form-item label="炉号"  v-if="companyName.includes('利佳')">
          <el-input v-model="ruleForm.heatNumber" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="库存预警数" prop="stockWarningNum"  v-if="companyName.includes('利佳')">
          <el-input-number v-model="ruleForm.stockWarningNum" :disabled="isShow"></el-input-number>
        </el-form-item>
        <el-form-item label="是否需要备件" prop="needSpare"  v-if="companyName.includes('利佳')">
          <el-radio-group v-model="ruleForm.needSpare" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒SCM系统" prop="isRemindScm" v-if="ruleForm.needSpare">
          <el-radio-group v-model="ruleForm.isRemindScm" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒APS系统" prop="isRemindAps" v-if="ruleForm.needSpare">
          <el-radio-group v-model="ruleForm.isRemindAps" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--        <el-form-item label="产品合格单">-->
        <!--          <comm-upload-file :files="ruleForm.productQualificationList" :limit="1" :readonly="isShow"-->
        <!--                            v-if="!isShow || (ruleForm.productQualificationList && ruleForm.productQualificationList.length > 0)"-->
        <!--                            @clk="finishUpload"></comm-upload-file>-->
        <!--          <span v-else>暂无</span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="是否需要委外检测" prop="isNeedOutsourcing">-->
        <!--          <el-radio-group v-model="ruleForm.isNeedOutsourcing" size="small" :disabled="isShow">-->
        <!--            <el-radio :label="true">是</el-radio>-->
        <!--            <el-radio :label="false">否</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <el-form-item label="检测批号" v-if="ruleForm.isNeedOutsourcing" prop="detectionBatchNumber">
          <el-input v-model="ruleForm.detectionBatchNo" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="合格证书" v-if="ruleForm.isNeedOutsourcing" prop="">
          <comm-upload-file :files="ruleForm.certQualityList" @clk="certUpload" :limit="1"
            :readonly="isShow"></comm-upload-file>
        </el-form-item>
        <el-form-item label="合格证有效期" v-if="ruleForm.isNeedOutsourcing">
          <el-date-picker v-model="ruleForm.certValidity" :disabled="isShow" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.sort" :readonly="isShow"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isShow">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddCustomer">确 定</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isShow">
        <el-button @click="closeDialog">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { addPageClass, pageClassList } from '@/api/customPageClass.js'
  import CommUploadFile from "@/components/CommUploadFile.vue";
  import { selectAllUnit } from '@/api/storeUnit.js'
  export default {
    name: "addPageClass",
    components: {
      // BaiduMap,
      CommUploadFile
    },
    props: [],

    data() {
      let token = localStorage.getItem("token")
      return {
        userInfo: '',
        companyName: '',
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: '添加产品类别',

        parentId: '',
        parentName: '顶级',
        treeProps: {
          children: 'children',
          label: 'allName',
          isLeaf: 'isLeaf'
        },
        expandOnClickNode: false,
        unitList: [],
        ruleForm: {
          id: '',
          name: '',
          sort: 999,
          parentId: null,
          busName: '',
          goodsCode: '',
          specCode: '',
          specName: '',
          classType: 0,
          stockWarningNum: '',
          partNumber: '',
          isRemindScm: false,
          isRemindAps: false,
          productQualification: '',
          isNeedOutsourcing: false,
          detectionBatchNo: '',
          certQuality: '',
          certValidity: '',
          productQualificationList: [],
          certQualityList: [],
          needSpare: false,
          inventCode: '',
          modelNo: '',
          unit: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入类别名称', trigger: 'blur' },
          ],
          busName: [
            { required: true, message: '请输入商家名称', trigger: 'blur' },
          ],
          goodsCode: [
            { required: true, message: '请输入货品编码', trigger: 'blur' },
          ],
          // specCode: [
          //   {required: true, message: '请输入规格码', trigger: 'blur'},
          // ],
          // specName: [
          //   {required: true, message: '请输入规格名称', trigger: 'blur'},
          // ],
          isRemindAps: [
            { required: true, message: '请选择是否提醒APS系统', trigger: 'blur' },
          ],
          isRemindScm: [
            { required: true, message: '请选择是否提醒SCM系统', trigger: 'blur' },
          ],
          isNeedOutsourcing: [
            { required: true, message: '请选择是否需要委外检测', trigger: 'blur' },
          ],
          detectionBatchNumber: [
            { required: true, message: '请输入检测批号', trigger: 'blur' },
          ],
          certValidity: [
            { required: true, message: '请输入合格证有效期', trigger: 'blur' },
          ],
          needSpare: [
            { required: true, message: '请选择是否需要备件', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            {
              type: 'number',
              message: '手机号格式不正确',
              trigger: 'blur',
              transform(value) {
                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                if (!phonereg.test(value)) {
                  return false
                } else {
                  return Number(value)
                }
              }
            }
          ]

        },
        type: 'add',
        id: '',
        classList: [{ value: 0, label: 'fadsfs' }],
        isShow: false,
        allData: "",
        isInitialRender: true,
        filterText: "",
        partNumber: "",
        specName: ""

      };
    },
    onShow() {

    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }

    },
    mounted() {
      this.getUnit()
    },
    watch: {
      filterText(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: 0,
          parentId: "",
          name: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      specName(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: 0,
          parentId: "",
          specName: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      partNumber(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: 0,
          parentId: "",
          partNumber: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
    },
    methods: {
      searchItem(params, val) {
        pageClassList(params)
          .then((res) => {
            console.log('aaa', res)
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            if (res.data.list && res.data.list.length == 0) {
              this.$message.error("没有找到相关的产品类别");
            }
            if (val) {
              this.classList =
                res.data.list && res.data.list.length > 0
                  ? res.data.list
                  : this.allData;
            } else {
              this.classList = this.allData;
            }
          })
          .catch((error) => {
            console.error("接口调用出错:", error);
          });
      },
      load(node, resolve) {
        if (this.isInitialRender) {
          this.isInitialRender = false;
          return resolve([]);
        }
        console.log('node', node)
        if ('顶级' == node.data.name || '顶级' == node.data.allName) {
          return resolve(node.data.children)
        } else {
          let params = {
            noPage: false,
            type: this.classType,
            classType: 0,
            status: this.storeStatus,
            parentId: node.data.id,
            name: this.filterText,
            specName: this.specName,
            partNumber: this.partNumber
          }
          pageClassList(params).then(res => {
            res.data.list.forEach(item => {
              item.isLeaf = !item.hasChildren
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            })
            node.data.children = res.data.list;
            return resolve(res.data.list)
          })
        }

      },
      finishUpload(files) {
        this.ruleForm.productQualificationList = files
      },
      certUpload(files) {
        this.ruleForm.certQualityList = files
      },
      handleCheckChange(node, list) {
        this.ruleForm.parentId = node.id;
        //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
        if (list.checkedKeys.length == 2) {
          //单选实现
          this.$refs.selectTree.setCheckedKeys([node.id]);
        }
      },
      getAllClass() {
        this.classList = []
        let params = {
          pageNum: 1,
          pageSize: 200,
          type: 0,
          classType: 0
        }
        pageClassList(params).then(res => {
          // this.classList = [{id:'',name:'顶级'}]
          // this.classList.push(res.data.list)
          res.data.list.forEach(item => {
            item.isLeaf = !item.hasChildren

            let namePart = item.name ? `${item.name}` : "";
            let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
            let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
            let specNamePart = item.specName ? `(${item.specName})` : "";
            item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
          })
          this.classList = [{ id: "", allName: "顶级", children: res.data.list }];
          this.allData = JSON.parse(JSON.stringify(this.classList));
          console.log('test', this.allData)
          this.$forceUpdate();
        })
      },
      getUnit() {
        selectAllUnit().then(res => {
          this.unitList = res.data
        })
      },
      async openDialog(type, data, classType) {
        this.getAllClass()
        this.dialogVisible = true
        this.classType = classType
        if (type === 'add') {
          this.title = '添加产品类别'
          this.type = 'add'
          this.resetForm()
          this.id = ''
          this.ruleForm.name = ''
          this.isShow = false
        } else if (type === 'edit') {
          this.ruleForm = JSON.parse(JSON.stringify(data))
          this.ruleForm.parentId = data.parentId
          this.parentName = '顶级'
          if (data.parentName) {
            this.parentName = data.parentName
          }
          this.title = '编辑产品类别'
          // this.getData(data)
          this.type = "edit"
          this.id = data.id
          this.isShow = false
        } else if (type === 'show') {
          this.ruleForm = data
          this.ruleForm.parentId = data.parentId
          this.parentName = '顶级'
          if (data.parentName) {
            this.parentName = data.parentName
          }
          this.title = '查看产品类别'
          this.isShow = true
          // this.getData(data)
        }
      },
      getChildrenList(data, arr) {
        if (data.children && data.children.length > 0) {
          data.children.forEach((item) => {
            this.getChildrenList(item, arr);
          });
        } else {
          arr.push(data);
        }
        return arr;
      },
      checkChildrenData(obj) {
        console.log('1111', obj)
        if (!obj.children) {
          return false;
        } else {
          obj.children.forEach((item) => {
            if (item.hasChildren) {
              this.checkChildrenData(item);
            }
          });
        }
        return true;
      },
      handleNodeClick(node) {
        console.log('node', node)
        if (!node.id) {
          this.ruleForm.parentId = null;
          this.parentName = '顶级';
        } else {
          this.ruleForm.parentId = node.id;
          this.parentName = node.allName || node.name; // 优先使用allName
        }

        // this.$refs.selectTree.blur();
      },
      // handleNodeClick(obj, node, item, index) {
      //   if (!obj.id) {
      //     this.$message.error("请选择下级节点");
      //     return;
      //   }
      //   if (obj.hasChildren) {
      //     let flag = this.checkChildrenData(obj);
      //     if (!flag) {
      //       this.$message.error("请点击箭头加载子级数据");
      //       return;
      //     }
      //   }
      //   let childrenList = this.getChildrenList(obj, []);
      //   childrenList.forEach((data) => {
      //     let number = this.ruleForm.addStoreCodeDtos[index].parentId.findIndex(
      //       (val) => val.id == data.id
      //     );
      //     if (number && number == -1) {
      //       if (data.parentId) {
      //         let number1 = this.ruleForm.addStoreCodeDtos[
      //           index
      //         ].parentId.findIndex((val) => val.id == data.parentId);
      //         if (number1 != -1) {
      //           this.$message.error("该节点父级已被选择");
      //           return;
      //         }
      //       }
      //       this.ruleForm.addStoreCodeDtos[index].parentId =
      //         this.ruleForm.addStoreCodeDtos[index].parentId.filter(
      //           (val) => val.parentId != data.id
      //         );
      //       this.ruleForm.addStoreCodeDtos[index].parentId.push({
      //         id: data.id,
      //         name: data.name,
      //         parentId: data.parentId,
      //         specName: data.specName,
      //       });
      //     }
      //     this.ruleForm.addStoreCodeDtos[index].parentName =
      //       this.ruleForm.addStoreCodeDtos[index].parentId.map((val) =>
      //         val.specName ? val.name + "(" + val.specName + ")" : val.name
      //       );
      //     this.ruleForm.addStoreCodeDtos[index].name =
      //       this.ruleForm.addStoreCodeDtos[index].parentName
      //         .map((val) => val)
      //         .join(",");
      //     let classRef = this.setClassRef(index);
      //     this.$nextTick(() => {
      //       this.$refs[classRef][0].blur();
      //     });
      //   });
      // },
      setValueNull() {
        this.ruleForm.parentId = '';
        this.parentName = ''
      },
      optionData(array, result = []) {
        array.forEach(item => {
          result.push({
            label: item.name,
            value: item.id
          })
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result)
          }
        })
        return JSON.parse(JSON.stringify(result))
      },
      closeDialog() {
        this.dialogVisible = false
        this.resetForm()
      },
      resetForm() {
        if (this.$refs.dealerRuleForm !== undefined) {
          this.$refs.dealerRuleForm.resetFields();
        }
      },
      async confirmAddCustomer() {
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            let typeId = null
            if (this.type === 'edit') {
              this.ruleForm.id = this.id
              addPageClass(this.ruleForm).then(res => {
                if (res.code === 200) {
                  this.$message({
                    type: "success",
                    message: "操作成功",
                  });
                  // this.$emit('getList')
                }
              })
            } else {
              this.ruleForm.id = ''
              addPageClass(this.ruleForm).then(res => {
                if (res.code === 200) {
                  const {name, id} = res.data;
                  const ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
                  this.$emit('getList', {...ruleForm, id, name})
                  this.$message({
                    type: "success",
                    message: "操作成功",
                  });
                }
              })
            }
            this.closeDialog()
          }
        })
      },
      // 回显
      getData(data) {
        this.ruleForm = data
        console.log('classList', this.classList)
        let obj = this.classList[0].children.filter(it => it.id === data.parentId);
        if (obj) {
          console.log('obj', obj)
          this.parentName = obj[0].name
        }
      },


    },


  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10 rpx;
  }
  .searchItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    .searchName {
      width: 130px;
      font-size: 14px;
    }
  }
  .tree-container {
    height: 400px;
    overflow-y: auto;
  }

  .virtual-scroller {
    width: 100%;
  }
</style>